module.exports = __webpack_public_path__ + "img/svg/plus-circle.78c7f4fe2d5b94aa4d2d783d3103f5a0.svg";